import { SPACING } from '@common/theme/spacing'
import { DeleteOutlineRounded, ExpandLessRounded, KeyboardArrowDownRounded } from '@mui/icons-material'
import { Collapse, Divider, IconButton, Paper, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { getOverrideCommentText } from '@common/utils/parseContainerComments'

export default function ExamReason({ reason, comment }: { reason: string; comment: string }) {
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  // Structured override key, or legacy plain text (old containers) when a reason exists.
  const overrideComment = getOverrideCommentText(comment)

  return (
    <Paper
      sx={{
        paddingX: SPACING.examReasonSpacingX,
        paddingY: SPACING.examDetailPopupMenuListSpacing,
        borderRadius: SPACING.borderRadiusXxl,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="body2">Site has not performed this examination</Typography>
          <Stack direction="row" spacing={SPACING.minSpacing} alignItems="center">
            <Divider orientation="vertical" flexItem />
            <IconButton>
              <DeleteOutlineRounded
                sx={{
                  width: 20,
                  height: 20,
                  color: 'text.secondary',
                }}
              />
            </IconButton>
          </Stack>
        </Stack>
        <Paper
          sx={{
            paddingX: SPACING.examReasonSpacingX,
            paddingY: SPACING.examReasonSpacingSm,
            borderRadius: SPACING.borderRadiusXxl,
            bgcolor: 'paper.main',
          }}
        >
          <Stack spacing={SPACING.examReasonSpacingX}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="subtitle2">Hide reason and comment</Typography>
              <IconButton onClick={() => setOpen(!open)}>
                {open ? (
                  <ExpandLessRounded
                    sx={{
                      width: 24,
                      height: 24,
                      color: 'text.secondary',
                    }}
                  />
                ) : (
                  <KeyboardArrowDownRounded
                    sx={{
                      width: 24,
                      height: 24,
                      color: 'text.secondary',
                    }}
                  />
                )}
              </IconButton>
            </Stack>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Stack spacing={SPACING.minSpacing}>
                <Stack spacing={SPACING.examReasonSpacingSm}>
                  <Typography
                    sx={{
                      color: 'text.secondary',
                    }}
                    variant="subtitle2"
                  >
                    Reason for Override
                  </Typography>
                  <Typography variant="body2">{reason}</Typography>
                </Stack>
                {overrideComment ? (
                  <Stack spacing={SPACING.examReasonSpacingSm}>
                    <Typography sx={{ color: 'text.secondary' }} variant="subtitle2">
                      Override comment
                    </Typography>
                    <Typography variant="body2">{overrideComment}</Typography>
                  </Stack>
                ) : null}
              </Stack>
            </Collapse>
          </Stack>
        </Paper>
      </Stack>
    </Paper>
  )
}
